
/**
 * The purpose of this is file is to share variables between
 * CSS and JS. E.g
 * 	In css: $primaryColor
 * 	in JS:
 * 		let variables = require('./variables.js');
 * 		console.log(variables.primaryColor);
 * 
 * Note that PostCSS does not allow you to reat properties of
 * variables so values must be simple (string, numbers, ...)
 * and not objects.
 */
module.exports = {
	screen_wrapper:		'1140px',
	screen_XL:			'1000px',
	screen_footerStack:	'640px',
	screen_tablet: 		'768px',
	screen_mobileMenu: 	'600px',
	screen_mobile: 		'640px',
	screen_smallest: 	'320px',
};